import * as UserManager from '../../SDK/UserManager'
// import * as Util from 'util'

const SHOW_MENU = true
const HIDE_MENU = false

const logout = {
  state: {
    isShow: false,
    settingInfo: {
      color: '',
      user_name: '',
      quota: '',
      used: ''
    }
  },
  getters: {
    getLogoutIsShow: state => state.isShow,

    getSettingInfo: state => state.settingInfo
  },
  mutations: {
    showLogout (state, obj) {
      state.isShow = SHOW_MENU
    },
    hideLogout (state) {
      state.isShow = HIDE_MENU
    },
    setSettingInfo (state, obj) {
      state.settingInfo.color = obj.color
      state.settingInfo.user_name = obj.user_name
      state.settingInfo.quota = obj.quota
      state.settingInfo.used = obj.used
    }
  },
  actions: {
    showLogoutInfo ({commit}, obj) {
      commit('showLogout', obj)
    },
    hideLogoutInfo ({commit}) {
      commit('hideLogout')
    },
    getInfo ({commit}, obj) {
      UserManager.getInfo(obj)
        .then(response => {
          commit('setSettingInfo', response)
        })
    },
    signout ({commit}, obj) {
      UserManager.signout(obj)
        .then(response => {
          localStorage.removeItem('userInfo')
          // Util.delCookie('X-LENOVO-SESS-ID')
          window.location = '/H5/'
        })
    }
  }
}
export default logout



// WEBPACK FOOTER //
// ./src/store/modules/logout.js